export const CompoundIndexSeparator = ':';
export const COMPLETED = true;
